import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={715}
    height={777}
    viewBox="0 0 715 777"
    fill="none"
    {...props}
  >
    <g opacity={0.1}>
      <path
        fill="#435288"
        d="m862.42 240.88-6.76 6.76-6.71 6.71-120.39 120.44-3.95 3.91-9.52 9.52-179.83-179.83-9.57-9.52L348.04 21.24l-8.57-8.57-8.48-8.48c6.53-.95 13.1-1.76 19.67-2.38 1.48-.14 3-.29 4.53-.38C366.05.48 377.14 0 388.24 0H621.5l240.93 240.88h-.01Z"
      />
      <path
        fill="#6AE5BC"
        d="m1009.77 388.23-6.72 6.76-2.81 2.76-3.95 3.95L875.9 522.14l-6.76 6.72-6.72 6.76L621.49 776.5H388.23C174.16 776.51 0 602.35 0 388.23c0-103.68 40.39-201.21 113.73-274.6 58.91-58.86 135.44-97.3 217.26-109.44l8.48 8.48 8.57 8.57 177.64 177.64 9.57 9.52H388.14c-99.15 0-179.83 80.67-179.83 179.83 0 48.05 18.72 93.2 52.67 127.16 34 34 79.15 52.72 127.16 52.72H535.2l179.88-179.88h294.7-.01Z"
      />
    </g>
  </svg>
)
export default SvgComponent
